import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { InspectionModelService } from '../../../shared/services/index';
import { InspectionSection } from '../../../shared/models/index';
import { BaseModalPageComponent } from '../../../base-modal.component';
import * as _ from 'lodash';

@Component({
    templateUrl: './open-inspection.component.html',
    standalone: false
})
export class AddPointOpenInspectionPageComponent extends BaseModalPageComponent implements OnInit {
  sections: InspectionSection[];
  inspectionId: string;
  sectionId: string;
  modelId: string;
  selectedInspectionSection: InspectionSection;
  errorMessage: string;
  public loading: Boolean = true;
  model: any;

  constructor(
    public service: InspectionModelService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      let id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      let sectionId = params['sectionId'];
      if (sectionId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.sectionId = sectionId;

      let targetInspectionId = params['targetInspectionId'];
      if (targetInspectionId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.modelId = targetInspectionId;

      this.initData();
    });
  }

  selectInspectionSection(inspectionSection: any): void {
    _.forEach(this.model.sections, (s: any) => {
      s.selected = false;
    });
    inspectionSection.selected = !inspectionSection.selected;
    this.selectedInspectionSection = inspectionSection;
    this.cdRef.detectChanges();
  }

  openSection(): void {
    this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'sections',
      this.sectionId,
      'addpoint',
      this.modelId,
      this.selectedInspectionSection.id
    ]);
  }

  cancel() {
    this.goToBack();
  }

  initData(): void {
    this.service.getModel(this.modelId).subscribe((model) => {
      this.model = model;
      this.loading = false;
    });
  }
}
